import React from "react";
import ImageCard from "./ImageCard.jsx";

export default function ImageCardWrapper({ item }) {
  if (!item) return null;
  return <ImageCard {...item} />;
}


